import { useAuth } from "@/context/AuthContext";

export default function BrandLogo({ size = 44, showText = true, textClass = "text-white", subtitle = true }) {
    const { school } = useAuth();
    return (
        <div className="flex items-center gap-3" data-testid="brand-logo">
            {school.logo_url ? (
                <img
                    src={school.logo_url}
                    alt="شعار المدرسة"
                    style={{ width: size, height: size }}
                    className="rounded-lg bg-white p-1 object-contain shadow-sm ring-1 ring-white/10"
                />
            ) : (
                <div
                    style={{ width: size, height: size }}
                    className="rounded-lg bg-white flex items-center justify-center text-[#1B2A4E] font-bold shadow-sm"
                >
                    <span className="text-lg">س</span>
                </div>
            )}
            {showText && (
                <div className="leading-tight">
                    <div className={`font-bold ${textClass}`} style={{ fontSize: size >= 44 ? "0.95rem" : "0.85rem" }}>
                        {school.app_name || "بقدراتنا نسمو"}
                    </div>
                    {subtitle && (
                        <div className={`text-xs ${textClass === "text-white" ? "text-white/70" : "text-slate-500"}`}>
                            {school.name}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
